/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Privacypolicy1Inputs */

const he_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מדיניות פרטיות`)
};

const en_footer_privacypolicy1 = /** @type {(inputs: Footer_Privacypolicy1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Footer_Privacypolicy1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const footer_privacypolicy1 = /** @type {((inputs?: Footer_Privacypolicy1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Privacypolicy1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_footer_privacypolicy1(inputs)
	return en_footer_privacypolicy1(inputs)
});
export { footer_privacypolicy1 as "footer_privacyPolicy" }